import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import Button from '#lib/components/button.jsx';
import { toast } from 'react-hot-toast';
import { ENVIRONMENTS } from '#lib/constants.js';

export default function StripeCheckout(props) {
    const { pack, coupon, discount, createCoupon } = props;
    const stripe = useStripe();
    const elements = useElements();
    const [busy, setBusy] = useState(false);
    let price = pack.price;
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!stripe || !elements) return;

        setBusy(true);
        const returnBaseUrl = ENV === ENVIRONMENTS.DEVELOPMENT ? 'http://localhost:8080' : `https://${APP_DOMAIN}`;

        if (coupon) createCoupon.mutate(coupon);
        if (price === 0)
            return await stripe.confirmSetup({
                elements,
                confirmParams: {
                    return_url: `${returnBaseUrl}/settings/payment`
                }
            });
        const result = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `${returnBaseUrl}/settings/payment`
            }
        });

        if (result.error) toast.error(result.error.message);
    };
    if (coupon) price = (Math.round(pack.price * (1 - (discount ?? 0) / 100) * 122) / 100).toFixed(2);
    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement />
            <div className="mt-3 text-right">
                <Button type="submit" look="primary" disabled={!stripe} busy={busy}>
                    {_t.billing.buyBtn()} / €{price}
                </Button>
            </div>
        </form>
    );
}
